import { SPRYKER_DDC_CONFIG_PATH } from '../constants';
import { DdcConfigApi } from '../types/api/ddc-config-api';
import { SprykerBaseRequestParams } from '../types/replatform/endpoints.types';
import { NetworkResponse } from '../types/services/request.types';
import { RequestHandler } from './requestHandler.service';
import { UrlBuilder } from './urlBuilder.service';

export class SprykerDdcConfigHandler extends RequestHandler {
  api = {
    target: 'spryker-ddc-config',
    default: 'spryker-default',
  };

  getDdcConfig({
    countryCode,
    languageCode,
    brand,
  }: SprykerBaseRequestParams): NetworkResponse<DdcConfigApi.GetDdcConfig> {
    return this.get<DdcConfigApi.GetDdcConfig>(
      UrlBuilder.buildSprykerURL({
        countryCode,
        languageCode,
        brand,
        endPointName: SPRYKER_DDC_CONFIG_PATH,
      }),
    );
  }
}

export const SprykerDdcConfig = new SprykerDdcConfigHandler();
